import { Card } from "@jhool-io/fe-components";
import { Link, useParams } from "react-router-dom";
import { removeEnumUnderscore } from "../../../utils/helpers";
import { NoteLabels } from "../../../modules/notes/types/notes.types";
import { useFetchSessionNote } from "../../../hooks/queries/note";
import Loader from "../../../shared-ui/Loader/Loader";
import ListState from "../../ListState/ListState";

interface NoteDetailsProps {
    /** Show Provider name */
    showProvider?: boolean;
}

export default function NoteDetails({
    // details,
    showProvider,
}: NoteDetailsProps) {
    const params = useParams();
    const noteId = params.noteId as string;
    const clientId = params.clientId as string;

    const { data, error, isLoading } = useFetchSessionNote(
        clientId,
        noteId,
        Boolean(clientId) && Boolean(noteId)
    );

    if (isLoading) {
        return <Loader wrapperClassName="h-[110px]" />;
    }

    if (error) {
        return (
            <ListState
                isError
                errorMsg={
                    error?.response?.data.message ||
                    "Cannot display note details at this time"
                }
                stateHelperText="Please try again later"
                context="general"
                cardClass="h-[110px]"
            />
        );
    }

    return (
        <Card>
            <h2 className="text-title mb-[--spacing-items]">NOTE DETAILS</h2>
            <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-[--spacing-items]">
                <div>
                    <p className="section-info">Client name</p>
                    <Link
                        to={`/clients/${data.data.client?.client_id}`}
                        className="text-textLink section-value underline"
                    >
                        {`${data.data.client?.first_name} ${data.data.client?.last_name}`}
                    </Link>
                </div>
                {showProvider && (
                    <div>
                        <p className="section-info">Provider name</p>
                        <p className="section-value">
                            {`${data.data.provider?.first_name} ${data.data.provider?.last_name}`}
                        </p>
                    </div>
                )}
                <div>
                    <p className="section-info">Note type</p>
                    <p className="section-value">
                        {NoteLabels[data.data.type]}
                    </p>
                </div>
                <div>
                    <p className="section-info">Appointment Type</p>
                    <p className="section-value">
                        {removeEnumUnderscore(
                            data.data.appointment_type || "--"
                        )}
                    </p>
                </div>
            </div>
        </Card>
    );
}
